<template>
  <div :data-pc-key="config.key" :class="getClass()" :style="getStyle()" draggable="true" :title="config.desc || config.text">
    <drop-position :text="getShowText()" :dropMode="dropMode" @remove="triggerRemove" @clone="clone"></drop-position>
    <el-row :gutter="properties.gutter">
      <component v-for="c in children" :key="c.key" :is="c.configComponent" :endpoint="endpoint" :group="group" :config="c" ref="childComponents" @remove="removeChild"></component>
    </el-row>
  </div>
</template>

<script>
import mixin from './mixin.js'
import { getConfigApi, getArrayItem } from '../util.js'

export default {
  name: 'pc-row-component',
  mixins: [mixin],
  data () {
    return {
      properties: {
        gutter: 0
      }
    }
  },
  created () {
    // 如果Row没有子Col，为Row添加默认的Col
    if (!this.config.children) {
      let total = 24
      let cols = 2
      if (cols > total) {
        cols = total
      }

      let percent = Math.ceil(total / cols)
      let left = total
      for (let i = 0; i < cols; i++) {
        let value = left > percent ? percent : left

        let colConfig = getConfigApi(this.endpoint, this.group, 'Col')
        getArrayItem('xs', colConfig.properties).value = value
        getArrayItem('sm', colConfig.properties).value = value
        getArrayItem('md', colConfig.properties).value = value
        getArrayItem('lg', colConfig.properties).value = value
        getArrayItem('xl', colConfig.properties).value = value
        this.addChild(colConfig)

        left = left - value
        if (left <= 0) {
          return
        }
      }
    }
  }
}
</script>
